import AlertsContainer from 'components/generic/AlertsContainer'
import AddOrManageModal from 'components/watchlist/modals/AddOrManageModal'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'
import {
  useAppInit,
  useLogOutUnauthenticated,
  useRegistrationEvent,
  useSubscribeToSocialMatchUpdates,
  useMyWatchlists,
  useMyProfile,
} from './hooks'

interface Props {
  enableSelfSubmission?: boolean
}

const User = ({ enableSelfSubmission }: Props) => {
  const isLoggedIn = useSelector((state: AppState) => state.user.isLoggedIn)
  const userStatus = useSelector((state: AppState) => state.user.userStatus)

  useAppInit()

  useMyProfile()

  useRegistrationEvent()

  useLogOutUnauthenticated({ isLoggedIn, userStatus })

  useMyWatchlists({ isLoggedIn, userStatus })

  useSubscribeToSocialMatchUpdates({ isLoggedIn, enableSelfSubmission })

  return (
    <>
      <AlertsContainer />
      {isLoggedIn && <AddOrManageModal />}
    </>
  )
}

export default User
